import { render } from "./SoundBoard.vue?vue&type=template&id=67a21ff6"
import script from "./SoundBoard.vue?vue&type=script&lang=js"
export * from "./SoundBoard.vue?vue&type=script&lang=js"

import "./SoundBoard.vue?vue&type=style&index=0&id=67a21ff6&lang=scss"

import exportComponent from "E:\\项目文件\\english_web_go\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__